/**
 * Waits for an element to be available in the DOM
 */
export const waitForElement = async (node: Document | Element, selector: string): Promise<Element | null> =>
  new Promise(resolve => {
    if (node.querySelector(selector)) {
      resolve(node.querySelector(selector));
    } else {
      const observer = new MutationObserver(() => {
        if (node.querySelector(selector)) {
          observer.disconnect();
          resolve(node.querySelector(selector));
        }
      });

      observer.observe(node, {
        childList: true,
        subtree: true
      });
    }
  });
